import React from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';
import kebabCase from 'lodash/kebabCase';
import { FormattedMessage, defineMessages } from 'react-intl';
import noop from 'lodash/noop';
import Button from '../Button';
import Header from '../Header';
import Image from '../Image';
import './styles.css';
import LockImage from './Lock.svg';

const messages = defineMessages({
  Upgrade: {
    id: 'subscription.module.upgrade',
    defaultMessage: 'Upgrade',
  },
});

class SubscriptionModuleComponent extends React.PureComponent {
  static propTypes = {
    name: PropTypes.string,
    category: PropTypes.node.isRequired,
    color: PropTypes.oneOf(['blue', 'purple', 'darkcyan', 'grey']).isRequired,
    title: PropTypes.node.isRequired,
    description: PropTypes.node.isRequired,
    buttonLabel: PropTypes.node.isRequired,
    image: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    showUpgrade: PropTypes.bool,
    // only required when 'showUpgrade' is true
    onTriggerUpgrade: PropTypes.func,
  };

  static defaultProps = {
    onTriggerUpgrade: noop,
  };

  onUpgradeClick = () => {
    this.props.onTriggerUpgrade(this.props.name);
  };

  render() {
    const {
      category,
      color,
      title,
      description,
      buttonLabel,
      image,
      link,
      showUpgrade,
    } = this.props;
    const headerId = kebabCase(title);
    return (
      <section aria-labelledby={headerId} styleName={`subscription-module ${color}`} data-cy={`subscription-module-${headerId}`}>
        <div styleName="module-category">{category}</div>
        <div styleName="module-image" aria-hidden="true">
          <Image alt="" src={image} />
        </div>
        {showUpgrade && <Image src={LockImage} aria-hidden="true" styleName="module-premium-lock" />}
        <div styleName="module-content">
          <Header as="h2" data-cy={`homepage-subscription-title-${kebabCase(buttonLabel)}`} id={headerId} size="large">{title}</Header>
          <div styleName="module-description">{description}</div>
          <div>
            {
              showUpgrade ? (
                <Button
                  type="button"
                  secondary
                  onClick={this.onUpgradeClick}
                  styleName="module-upgrade-button"
                  data-cy={`subscription-module-button-${headerId}`}
                >
                  <FormattedMessage {...messages.Upgrade} />
                </Button>
              ): (
                <Button
                  as={Link}
                  to={link}
                  styleName="module-button"
                  data-cy={`subscription-module-button-${headerId}`}
                >
                  {buttonLabel}
                </Button>
              )
}
          </div>
        </div>
      </section>
    );
  }
}

export default SubscriptionModuleComponent;
